import React, { useEffect, useRef } from 'react';
import '../css/review.css';

function Review() {
  const reviewSectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          reviewSectionRef.current.classList.add('visible');
        } else {
          reviewSectionRef.current.classList.remove('visible'); // Remove class when out of view
        }
      },
      { threshold: 0.1 }
    );

    if (reviewSectionRef.current) {
      observer.observe(reviewSectionRef.current);
    }

    return () => {
      if (reviewSectionRef.current) {
        observer.unobserve(reviewSectionRef.current);
      }
    };
  }, []);

  const reviews = [
    {
      // Removed invalid style property
      name: 'Kevin Lehmann',
      text: 'Quality pharmacy Family owned by Mark .\nWith caring employees\nThey aim to pleases.',
      rating: 5,
      reviewsCount: '',
      style: { textAlign: 'justify' },
    },
    {
      name: 'Kathy Donoghue',
      text: "Mark and his staff are friendly, courteous and always ready to go the extra mile.\n I chose Quality after my former Pharmacy closed several years ago. Honestly, I did not even know they were there. Had I known I would have chosen them from the start. Mark is always available to answer any questions, and if he is busy he will call back or give a time to call him back. 5 stars are not enough to indicate the level of care given to his customers. This pharmacy blows away all the big chain pharmacies 💯. If you are tired of waiting in lines for service without a smile, why not give a caring Independent owner a try. You won't be disappointed. 👌👍🤗",
      rating: 5,
      reviewsCount: '',
      style: { textAlign: 'justify' },
    },
    {
      name: 'JoAnne Bates',
      text: 'I switched from Walgreens to Quality Pharmacy years ago. Best decision ever! Mark is amazing. Love that everyone here knows your name, always greets you, super nice, takes the time speaking to you with your concerns. No more than a 10 minute wait on getting a prescription. Over all wonderful pharmacy, staff and owner.',
      rating: 5,
      reviewsCount: '',
      style: { textAlign: 'justify' },
    },
  ];

  return (
    <div ref={reviewSectionRef} className="review-section">
      <h2 className="review-title">What our customers say</h2>
      <div className="review-container" style={{ textAlign: 'justify' }}>
        {reviews.map((review, index) => (
          <div key={index} className="review-card" >
            <div className="review-rating">
              {'★'.repeat(review.rating)}
            </div>
            <p className="review-text">{review.text}</p>
            <div className="review-author">
              <div className="review-author-icon">
                <svg
                  width="40"
                  height="40"
                  fill="#7cb518"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 12c2.7 0 8 1.34 8 4v2H4v-2c0-2.66 5.3-4 8-4zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0 2c-2.67 0-8 1.34-8 4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </div>
              <div>
                <span className="review-author-name">{review.name}</span>
                <span className="review-author-details">{review.reviewsCount}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Review;